import appConfig from '@/apps/apckpi/app.config.js'
export default [
  {
    path: "apckpi",
    name: "apckpi",
    redirect: "Overview"
  },
    {
      path: 'PlantUnit',
      name: 'Site Unit',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/PlantUnit.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'MasterData',
      name: 'MasterData',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/MasterData.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'PolymerLookUp',
      name: 'Polymer LookUp',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/PolymerLookUp.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'AnalyzerTags',
      name: 'Analyzer Tags',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/AnalyzerTags.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'User',
      name: 'User',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/User.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'Overview',
      name: 'Overview',
      component: () => import(/* webpackChunkName: "apckpi-PlantUnit" */ '../views/Overview.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'ApcController',
      name: 'Controller Info',
      component: () => import(/* webpackChunkName: "Incubator-ApcController" */ '../views/ApcController.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'AddController',
      name: 'AddController',
      component: () => import(/* webpackChunkName: "Incubator-IncubatorHome" */ '../views/AddController.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'KpiData',
      name: 'KpiData',
      component: () => import(/* webpackChunkName: "Incubator-IncubatorHome" */ '../views/KpiData.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'KPIBulkEdit',
      name: 'KPIBulkEdit',
      component: () => import(/* webpackChunkName: "Incubator-IncubatorHome" */ '../views/KPIBulkEdit.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'DataValidation',
      name: 'Import Data',
      component: () => import(/* webpackChunkName: "Incubator-IncubatorHome" */ '../views/DataValidation.vue'),
      meta: {
        mainNavEnabled: false,
      },
    },
    {
      path: 'Log',
      name: 'Log',
      component: () => import(/* webpackChunkName: "Incubator-IncubatorHome" */ '../views/Log.vue'),
      meta: {
        mainNavEnabled: false,
      },
    }
]
